// extracted by mini-css-extract-plugin
export default {"container":"StudentForm_container__IkMRM","logo":"StudentForm_logo__K4Udf","box":"StudentForm_box__6npYM","sucessbox":"StudentForm_sucessbox__TrvjE"};